
  <div class='container'>

    <data-table
    [title]='titleMemorandos'
    [columns]='columnasMemorandos'
    [configuration]='configurationMemorandos'
    [reloadTable]='recargarTablaMemorandos'
    (add)='agregarMemorandos($event)'
    (edit)='editarMemorandos($event)'
    (delete)='eliminarMemorandos($event)'
    (selection)='seleccionadosMemorandos($event)'
    (view)='viewMemorandum( $event)'
    [params]='[]'
    [url]='urlGetMemorandos'
    ></data-table>

  </div>
